// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ViewThumbnails(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ViewThumbnails" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M11 11H4V4H11V11Z", fill: "currentColor" }),
            React.createElement("path", { d: "M11 20H4V13H11V20Z", fill: "currentColor" }),
            React.createElement("path", { d: "M13 11H20V4H13V11Z", fill: "currentColor" }),
            React.createElement("path", { d: "M20 20H13V13H20V20Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ViewThumbnails.js.map